<template>
  <div class="filter-by-location-checkbox">
    <UICheckbox
      :model-value="props.isChecked"
      :loading="isLoading"
      class="filter-by-location-checkbox__custom"
      :order="isMobile ? 'icon-first' : 'text-first'"
      :is-disabled="!!error"
      :is-error="!!error"
      @update:model-value="emit('update:isChecked', $event)"
    >
      <template v-if="!error">Показать только в моем городе</template>
      <template v-else>
        <span>Ошибка при определении вашего города</span>
      </template>
    </UICheckbox>
  </div>
</template>

<script setup lang="ts">
  import UICheckbox from '@/components/common/UICheckbox.vue';
  import { useClientSize } from '@/composables/useClientSize';

  const props = defineProps<{
    isChecked: boolean;
    isLoading: boolean;
    error?: Error | null;
  }>();

  const emit = defineEmits<{
    (e: 'update:isChecked', value: boolean): void;
  }>();

  const { isMobile } = useClientSize();
</script>

<style scoped>
  .filter-by-location-checkbox {
    display: flex;
    align-items: center;
  }

  .filter-by-location-checkbox__custom {
    padding-right: 5px;
  }

  .filter-by-location-checkbox__custom :deep(.c-custom-checkbox__text) {
    /* font-size: 14px;
    white-space: nowrap;
    color: #555;
    font-weight: 500; */
  }
  @media (--mobile) {
    .filter-by-location-checkbox__custom :deep(.c-custom-checkbox__text) {
      font-size: 12px;
    }
  }
</style>
